// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-dh-plastic-counter-root","app":"dh-dh-plastic-counter-app","app--medium":"dh-dh-plastic-counter-app--medium","app--large":"dh-dh-plastic-counter-app--large","app--extra-large":"dh-dh-plastic-counter-app--extra-large"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/App.css
// module id = 4
// module chunks = 0